"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Dialog_1 = require("./Dialog");
const { paper } = Dialog_1.dialogClasses;
const MuiDialogOverrides = {
    MuiDialog: {
        styleOverrides: {
            paper: ({ theme }) => ({
                [`&.${paper}`]: {
                    boxShadow: theme.shadows[8],
                }
            }),
        },
    },
};
exports.default = MuiDialogOverrides;
//# sourceMappingURL=MuiDialogOverrides.js.map